var _g, _g2, _g3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBasicSurveyProfile = function SvgBasicSurveyProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 329 164"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2BD675",
    filter: "url(#Basic_Survey_Profile_svg__a)",
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 73.5,
    r: 21,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M76.626 73.5h-4.25l-3.187 9.562-6.375-19.125-3.188 9.563h-4.25"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#2BD675",
    filter: "url(#Basic_Survey_Profile_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 123.5,
    r: 29,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M114.758 139.016a1.415 1.415 0 1 0 0-2.83 1.415 1.415 0 0 0 0 2.83M130.313 139.018a1.414 1.414 0 1 0 0-2.828 1.414 1.414 0 0 0 0 2.828M103.445 109.32h5.656l3.79 18.935a2.83 2.83 0 0 0 2.829 2.277h13.745a2.82 2.82 0 0 0 2.828-2.277l2.263-11.864h-24.04"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Basic_Survey_Profile_svg__c)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 130,
    r: 17,
    stroke: "#2BD675",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD675",
    d: "M24 144v-2.223c0-.807-.334-1.593-.945-2.181a3.4 3.4 0 0 0-2.345-.929h-8.088c-.889 0-1.73.34-2.344.929a1.334 1.334 0 0 1-1.849-1.922A6.05 6.05 0 0 1 12.622 136h8.088c1.563 0 3.072.597 4.193 1.674a5.7 5.7 0 0 1 1.763 4.103V144A1.333 1.333 0 0 1 24 144M20 128.667a3.334 3.334 0 1 0-6.667 0 3.334 3.334 0 0 0 6.667 0m2.667 0a6 6 0 1 1-12 0 6 6 0 0 1 12 0M31.108 129.676a1.332 1.332 0 1 1 1.784 1.982l-4.444 4a1.334 1.334 0 0 1-1.784 0l-2.222-2a1.333 1.333 0 0 1 1.678-2.068l.106.086 1.329 1.196z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2BD675",
    d: "M192.967 32.37C180.962 45.431 173.632 62.86 173.632 82c0 13.558 3.677 26.256 10.089 37.153a6.05 6.05 0 0 1 1.456-2.191c5.104-4.908 11.98-7.628 19.1-7.628h36.848c7.12 0 13.995 2.72 19.1 7.628 5.112 4.915 8.031 11.632 8.032 18.69v10.126a6.076 6.076 0 0 1-12.149 0v-10.126c0-3.679-1.517-7.258-4.3-9.935-2.793-2.686-6.634-4.235-10.683-4.236h-36.848c-4.048.001-7.884 1.551-10.677 4.236a6.05 6.05 0 0 1-4.23 1.692c13.436 17.028 34.256 27.959 57.63 27.959 20.215 0 38.519-8.176 51.789-21.401v11.61C284.669 157.093 266.641 164 247 164c-45.287 0-82-36.713-82-82 0-18.654 6.23-35.853 16.722-49.63zm29.738 16.222c15.095 0 27.333 12.238 27.333 27.333s-12.237 27.333-27.333 27.334c-15.096 0-27.334-12.238-27.334-27.334.001-15.096 12.239-27.333 27.334-27.333m0 12.148c-8.386 0-15.185 6.799-15.185 15.185s6.799 15.185 15.185 15.185 15.185-6.799 15.185-15.185c-.001-8.386-6.799-15.184-15.185-15.185"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Basic_Survey_Profile_svg__a",
    width: 53,
    height: 53,
    x: 41,
    y: 47,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_6170_707",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Basic_Survey_Profile_svg__b",
    width: 69,
    height: 69,
    x: 86,
    y: 89,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_6170_707",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Basic_Survey_Profile_svg__c",
    width: 44,
    height: 44,
    x: 0,
    y: 108,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_6170_707",
    stdDeviation: 2
  })))));
};
export default SvgBasicSurveyProfile;